var hugggDeliveryReportMap = {
  id: 'id',
  hugggId: 'hugggId',
  deliveryMethodId: 'deliveryMethodId',
  emailId: 'emailId',
  email: 'email',
  smsId: 'smsId',
  sms: 'sms',
  dateCreated: 'dateCreated',
  dateModified: 'dateModified'
};
export default hugggDeliveryReportMap;